import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const DoorIcon = (props: IconProps) => (
  <Icon w="18px" h="18px" viewBox="0 0 18 18" {...props}>
    <path d="M14.25 14.25V3.75c0-.825-.675-1.5-1.5-1.5h-7.5c-.825 0-1.5.675-1.5 1.5v10.5h-1.5v1.5h13.5v-1.5h-1.5Zm-1.5 0h-7.5V3.75h7.5v10.5Zm-3-6h1.5v1.5h-1.5v-1.5Z" />
  </Icon>
);

export default memo(DoorIcon);
